<div>
    <div class="card m-3">
        <h5 class="card-header" style="font-size: 21px">
            Exam Related Issue Details
        </h5>
        <div class="card-body">

            <form [formGroup]="eriStatusForm" (ngSubmit)="onSubmit()">
                <div class="form-row">
                    <div class="form-group col-12">
                        <h2>Ticket Details</h2>
                    </div>
                    <div class="form-group col-3">
                        <label>Ticket Id</label>
                        <input type="text" class="form-control" [value]="trackId_refno" [attr.disabled]='true' />
                    </div>

                    <div class="form-group col-3">
                        <label> Issue submitted</label>
                        <input type="text" class="form-control" [value]="trackId_ntef" [attr.disabled]='true' />
                    </div>

                    <div class="form-group col-3">
                        <label>Issue detail</label>
                        <input type="text" class="form-control" [value]="trackId_issuedetail" [attr.disabled]='true' />
                    </div>

                    <div class="form-group col-3">
                        <label>Description</label>
                        <input type="text" class="form-control" [value]="trackId_description" [attr.disabled]='true' />
                    </div>
                    <div class="form-group col-3">
                        <label>Invigilator Name</label>
                        <input type="text" class="form-control" formControlName="invigname"
                            [value]="trackId_invigi_name" [attr.disabled]='true' />
                    </div>

                    <div class="form-group col-12">
                        <hr>
                    </div>
                </div>
                <div class="form-row">
                    <div class="form-group col-12">
                        <h2>Candidate Details</h2>
                    </div>
                    <div class="form-group col-3">
                        <label>Reg No</label>
                        <input type="text" class="form-control" [value]="trackId_regno" [attr.disabled]='true' />
                    </div>

                    <div class="form-group col-3">
                        <label>Name</label>
                        <input type="text" class="form-control" [value]="trackId_name" [attr.disabled]='true' />
                    </div>
                    <div class="form-group col-3">
                        <label>Invigilator Email ID</label>
                        <input type="text" class="form-control" [value]="trackId_invigi_email" [attr.disabled]='true' />
                    </div>
                    <div class="form-group col-3">
                        <label>ITI code</label>
                        <input type="text" class="form-control" [value]="trackId_iticode" [attr.disabled]='true' />
                    </div>

                    <div class="form-group col-3">
                        <label>Trade</label>
                        <input type="text" class="form-control" [value]="trackId_trade" [attr.disabled]='true' />
                    </div>

                    <div class="form-group col-3">
                        <label>State</label>
                        <input type="text" class="form-control" [value]="trackId_state" [attr.disabled]='true' />
                    </div>

                    <div class="form-group col-3">
                        <label>District</label>
                        <input type="text" class="form-control" [value]="trackId_district" [attr.disabled]='true' />
                    </div>

                    <div class="form-group col-3">
                        <label>Date</label>
                        <input type="text" class="form-control" [value]="trackId_date" [attr.disabled]='true' />
                    </div>

                    <div class="form-group col-3">
                        <label>Attendance</label>
                        <input type="text" class="form-control" [value]="trackId_attendance" [attr.disabled]='true' />
                    </div>

                    <div class="form-group col-3">
                        <label>Exam Status</label>
                        <input type="text" class="form-control" [value]="trackId_status" [attr.disabled]='true' />
                    </div>
                    <div class="form-group col-12">
                        <hr>
                    </div>
                </div>
                <div class="form-row">
                    <div class="form-group col-12">
                        <h2>Grievance Remarks</h2>
                    </div>
                    <div class="form-group col-3">
                        <label>Grievance Status</label>
                        <select formControlName="status" class="form-control"
                            [ngClass]="{ 'is-invalid': submitted && f.status.errors }">
                            <option value="resolved">Resolved</option>
                            <option value="rejected">Rejected</option>
                        </select>
                        <div *ngIf="submitted && f.status.errors" class="invalid-feedback">
                            <div *ngIf="f.status.errors.required">status is required</div>
                        </div>

                    </div>

                    <div class="form-group col-12">
                        <label>Remarks</label>
                        <textarea class="form-control" formControlName="statusDescription"
                            [ngClass]="{ 'is-invalid': submitted && f.statusDescription.errors }" maxlength="500"
                            (keypress)="omit_spl($event)"></textarea>
                        <div *ngIf="submitted && f.status.errors" class="invalid-feedback">
                            <div *ngIf="f.statusDescription.errors.required">statusDescription is required</div>
                        </div>

                    </div>

                    <div class="form-group col-12">
                        <hr>
                    </div>

                    <div class="form-group col-12">


                        <button class="btn btn-primary mr-1">Submit</button>

                    </div>
                </div>
            </form>

        </div>
    </div>
</div>